import * as React from "react"

const LineColor4 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={56}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 56`}


            >
                <path
                    id={"line-color-4"}

                    ref={pathRef}

                    d="M0 0V56H2V0H0Z"
                    fill="#3F37C9"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor4
